import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["token", "timestamp"]

  connect() {
    const timestamp = Date.now()
    const token = this.generateToken(timestamp)

    if (this.hasTokenTarget) {
      this.tokenTarget.value = token
    }

    if (this.hasTimestampTarget) {
      this.timestampTarget.value = timestamp
    }
  }

  generateToken(timestamp) {
    const random = Math.random().toString(36).substring(2, 10)
    return btoa(`${timestamp}:${random}`)
  }
}
